import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from './Button';
export default function ActionButtons(props) {
    const { onDone, onCancel, doneLabel = 'Apply', cancelLabel = 'Cancel', style = {}, } = props;
    return (_jsxs("div", { style: { margin: '0 10px', display: 'flex', ...style }, children: [_jsx(Button.Done, { onClick: onDone, style: style?.flexDirection === 'row-reverse'
                    ? {
                        marginLeft: '10px',
                    }
                    : {}, children: doneLabel }), _jsx(Button.Danger, { fill: "outline", onClick: onCancel, style: !style.flexDirection || style.flexDirection === 'row'
                    ? {
                        marginLeft: '10px',
                    }
                    : {}, children: cancelLabel })] }));
}
